/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */

/**
 * Preferred Slovenian accounting export format.
 * @nullable
 */
export type GetSloveniaTaxProfile200AccountingExportsPreferredFormat = typeof GetSloveniaTaxProfile200AccountingExportsPreferredFormat[keyof typeof GetSloveniaTaxProfile200AccountingExportsPreferredFormat] | null;


export const GetSloveniaTaxProfile200AccountingExportsPreferredFormat = {
  vod_xml: 'vod_xml',
  vasco_xml: 'vasco_xml',
  minimax_xml: 'minimax_xml',
} as const;
